import React from 'react';
import { Typography, Grid, FormControl, InputLabel, Select, MenuItem, Input } from '@material-ui/core';

import { Form } from '../../components/Form';

interface AddProfileProps {
  classes?: any;
  rowData: any;
  participantCode: any;
  error: any;
  workflowList: any;
  isEdit: boolean;
  handleChangeWorkflow: (e: any) => void;
  workflowCode: any;
  subService: any;
  getLatestValues: (e: any) => void;
  dataConfig: any;
  handleProfileSubmit: (values: any) => void;
  handleChangeSubService: (e: any) => void;
  ResetForm: any;
}

const AddProfile = (props: AddProfileProps) => {
  const {
    classes,
    rowData,
    participantCode,
    error,
    workflowCode,
    handleChangeWorkflow,
    handleChangeSubService,
    isEdit,
    workflowList,
    getLatestValues,
    dataConfig,
    handleProfileSubmit,
    subService,
    ResetForm
  } = props;

  return (
    <Grid container alignItems="center" style={{ borderBottom: '1px solid #ececec' }} id="header">
      <Grid container style={{ padding: '10px 20px' }}>
        <Grid item xs={3}>
          <Typography className={classes.typographyLabel} variant="h3" style={{ marginTop: '15px' }}>
            Profile Config <b> - {rowData?.participantCode || participantCode}</b>
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <FormControl required={true} className={classes.selectField}>
            <InputLabel
              id="transform-spec-operationCode-label"
              className={`${error?.service !== '' ? 'Mui-error' : ''}`}
            >
              Service
            </InputLabel>
            <Select
              data-id="transform-spec-operationCode"
              className={`${classes.textField} ${error?.service !== '' ? 'Mui-error' : ''}`}
              label="Operation"
              value={workflowCode || ''}
              onChange={handleChangeWorkflow}
              disabled={isEdit}
            >
              {workflowList.data?.workflow?.content?.map((workflow: any) => [
                <MenuItem value={workflow?.workflowCode}>{workflow?.workflowName}</MenuItem>
              ])}
            </Select>
            {error?.service && <span style={{ color: '#EF4242', fontSize: '10px' }}>{error?.service}</span>}
          </FormControl>
        </Grid>
        {dataConfig?.map(
          (item: any) =>
            item?.group === 'header' && (
              <Grid item xs={4}>
                <FormControl required={true} className={classes.selectField}>
                  <InputLabel
                    id="transform-spec-operationCode-label"
                    className={`${error?.subService !== '' ? 'Mui-error' : ''}`}
                  >
                    {item?.label}
                  </InputLabel>
                  <Input
                    className={`${classes.textField} ${error?.subService !== '' ? 'Mui-error' : ''}`}
                    value={subService}
                    name={item?.key}
                    onChange={handleChangeSubService}
                  />
                  {error?.subService && <span style={{ color: '#EF4242', fontSize: '10px' }}>{error?.subService}</span>}
                </FormControl>
              </Grid>
            )
        )}
        <Grid item xs={1}>
          <ResetForm />
        </Grid>
      </Grid>
      {rowData?.participantCode !== '' ? (
        <Grid container>
          {/* eslint-disable-next-line react-hooks/exhaustive-deps */}
          {Object.keys(rowData).map((key: any) => {
            if (key === 'participant') {
              return Object.keys(rowData['participant']).map((participantKey: any) => {
                if (participantKey !== 'additionalCreds' && participantKey !== 'hibernateLazyInitializer')
                  return (
                    <Grid item xs={4} style={{ padding: '10px', border: '1px solid #ececec' }}>
                      {participantKey}: <b>{rowData['participant'][participantKey]}</b>
                    </Grid>
                  );
              });
            } else if (key !== 'participant' && key !== 'tableData') {
              return (
                <Grid item xs={4} style={{ padding: '10px', border: '1px solid #ececec' }}>
                  {key}: <b>{rowData[key]}</b>
                </Grid>
              );
            }
          })}
        </Grid>
      ) : (
        <>
          {dataConfig?.length > 0 && (
            <Form
              className={classes.root}
              dataConfig={dataConfig?.filter((item: any) => item?.group !== 'header')}
              handleDialogSubmit={handleProfileSubmit}
              submitlabel="Submit"
              getLatestValues={getLatestValues}
            ></Form>
          )}
        </>
      )}
    </Grid>
  );
};

export default AddProfile;
